import React from "react";

function PythonProgramingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="56" fill="none">
      <path
        fill="#197CE0"
        fillRule="evenodd"
        d="M4.153 0A3.975 3.975 0 00.178 3.961l-.164 48.05A3.975 3.975 0 003.989 56h54.94c2.2 0 3.982-1.788 3.975-3.989l-.165-48.05A3.975 3.975 0 0058.764 0H4.154zm8.561 11.248c-.732 0-1.326.595-1.325 1.327l.041 32.177h40.057l.041-32.177a1.325 1.325 0 00-1.325-1.327H12.714z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#a)"
        d="M45.024 31.669a1.4 1.4 0 01-1.98 0l-8.298-8.299a1.4 1.4 0 010-1.98l3.3-3.3a1.4 1.4 0 011.98 0l8.298 8.299a1.4 1.4 0 010 1.98l-3.3 3.3z"
      ></path>
      <path
        fill="url(#b)"
        d="M48.324 26.767a1.4 1.4 0 010 1.98l-8.298 8.298a1.4 1.4 0 01-1.98 0l-3.3-3.3a1.4 1.4 0 010-1.98l8.298-8.298a1.4 1.4 0 011.98 0l3.3 3.3z"
      ></path>
      <path
        fill="url(#c)"
        d="M17.97 31.583a1.4 1.4 0 001.98 0l8.298-8.298a1.4 1.4 0 000-1.98l-3.3-3.3a1.4 1.4 0 00-1.98 0l-8.298 8.299a1.4 1.4 0 000 1.98l3.3 3.3z"
      ></path>
      <path
        fill="url(#d)"
        d="M14.67 26.682a1.4 1.4 0 000 1.98l8.298 8.298a1.4 1.4 0 001.98 0l3.3-3.3a1.4 1.4 0 000-1.98l-8.299-8.298a1.4 1.4 0 00-1.98 0l-3.3 3.3z"
      ></path>
      <path
        fill="url(#e)"
        d="M47.342.018H60.12a2.65 2.65 0 012.65 2.65v12.777H49.992a2.65 2.65 0 01-2.65-2.65V.018z"
      ></path>
      <path
        fill="url(#f)"
        d="M11.416 44.756h40.079s1.093 5.07-8.927 11.2H19.432c-8.016-5.187-8.016-11.2-8.016-11.2z"
      ></path>
      <defs>
        <linearGradient
          id="a"
          x1="41.535"
          x2="41.535"
          y1="17.681"
          y2="33.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="41.535"
          x2="41.535"
          y1="17.681"
          y2="33.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
        <linearGradient
          id="c"
          x1="21.459"
          x2="21.459"
          y1="17.595"
          y2="33.775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
        <linearGradient
          id="d"
          x1="21.459"
          x2="21.459"
          y1="17.595"
          y2="33.775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
        <linearGradient
          id="e"
          x1="55.056"
          x2="55.056"
          y1="0.018"
          y2="12.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
        <linearGradient
          id="f"
          x1="31.473"
          x2="31.473"
          y1="40.79"
          y2="53.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#243FA0"></stop>
          <stop offset="1" stopColor="#1A77DB"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PythonProgramingIcon;
